import { addDaysKey, osloDateKey } from "../misc/osloDate";
import type { CompanyProduct } from "../types";

// Løpende avtaler (analysen v2, pakke F): kundeprodukter med periode måned,
// kvartal eller år som ikke er avsluttet.

// Fornyelser innen så mange dager regnes som «snart».
export const RENEWAL_SOON_DAYS = 60;
// Vedlikehold eldre enn så mange måneder (eller aldri) trenger et blikk.
export const MAINTENANCE_STALE_MONTHS = 6;

export const isActiveAgreement = (
  row: Pick<CompanyProduct, "billing_interval" | "end_date">,
  today = osloDateKey(),
) =>
  row.billing_interval !== "one_time" &&
  (!row.end_date || row.end_date >= today);

export type RenewalState = "overdue" | "soon" | "later" | "none";

export const renewalState = (
  renewalDate: string | null | undefined,
  today = osloDateKey(),
): RenewalState => {
  if (!renewalDate) return "none";
  if (renewalDate < today) return "overdue";
  if (renewalDate <= addDaysKey(today, RENEWAL_SOON_DAYS)) return "soon";
  return "later";
};

const monthsBack = (today: string, months: number) => {
  const [y, m, d] = today.split("-").map(Number);
  const date = new Date(Date.UTC(y, m - 1 - months, 1));
  const lastDay = new Date(
    Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0),
  ).getUTCDate();
  date.setUTCDate(Math.min(d, lastDay));
  return date.toISOString().slice(0, 10);
};

export const isMaintenanceStale = (
  lastMaintainedOn: string | null | undefined,
  today = osloDateKey(),
) =>
  !lastMaintainedOn ||
  lastMaintainedOn < monthsBack(today, MAINTENANCE_STALE_MONTHS);
